import React, { useState, useEffect } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup,
  LinearProgress,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialBox from "../../../components/MaterialBox";
import MaterialInput from "../../../components/MaterialInput";
import MaterialButton from "../../../components/MaterialButton";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import loading from "../../../assest/images/loading.svg";
import error from "../../../assest/images/404.svg";
import Swal from "sweetalert2";
import { useUserDetails } from "../../../context/auth";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLoading } from "../../../context/loading";

const Rollcreation = () => {
  const navigate = useNavigate();

  const [id, setId] = useState(null);
  const [loading, setLoading] = useState(false);
  const { circleLoading, setCirleLoading } = useLoading();
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const { AccessData } = useUserDetails();

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const [roleData, setroleData] = useState({
    roleName: "",
    description: "",
    roleNameStatus: "unchecked",
    descriptionStatus: "unchecked",
  });

  const [originalroleData, setOriginalroleData] = useState({
    roleName: "",
    description: "",
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getInitData(id);
    } else {
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    }
  }, []);

  const onDepartmentSubmit = async () => {
    const query = `mutation create_role($input: RolesCreateInput!){
  createRole(input: $input){
    message
    success
    error
  }
}`;

    const formatedvalue = {
      input: {
        role: roleData.roleName,
        description: roleData.description,
      },
    };


    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: formatedvalue,
        }),
      });


      let result = response.data.data.createRole;

      if (result.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Role Created successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        setTimeout(() => {}, 2000);
        navigate("/rollcreationlist");
      }

      setConfirmationDialog({ ...confirmationDialog, open: false });
      setSnackBar({
        ...snackBar,
        Success: true,
      });
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const onEditDepartmentSubmit = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to Update Bonus Details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        setConfirmationDialog({ ...confirmationDialog, open: false });
        // setLoading(true);
        setCirleLoading(true);
        try {
          const response = await axios({
            url: BASEURL,
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            data: JSON.stringify({
              query,
              variables: {
                input: {
                  id: id, // Include id as part of input if required by schema
                  role: roleData.roleName,
                  description: roleData.description,
                },
              },
            }),
          });
    
          let result = response.data.data.updateRole;
          if (result.success) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Role Updated successfully!",
              showConfirmButton: false,
              timer: 2500,
            });
            navigate("/rollcreationlist");
          }
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
          setSnackBar({
            ...snackBar,
            Success: true,
          });
        } catch (error) {
          console.error("responseError:", error);
          setConfirmationDialog({
            open: true,
            title: "Error massage",
            message:
              "Sorry for your inconvience, there is some issue in our network. Please try again later.",
            showCancel: true,
            showConfirm: false,
    
            onCancel: () => {
              setConfirmationDialog({
                ...confirmationDialog,
                open: false,
              });
            },
          });
        }
        finally{
          // setLoading(false);
          setCirleLoading(false);
        }
      },
      onCancel: () => {
        setConfirmationDialog({ ...confirmationDialog, open: false });
      },
    })
    // setPageState({
    //   ...pageState,
    //   state: "submitting",
    // });
    const query = `mutation update_role($input: RolesUpdateInput!){
  updateRole(input: $input){
    message
    success
    error
  }
}`;

   
  };

  const getInitData = async (id) => {
    setPageState({
      ...pageState,
      loading: true,
      state: "init",
    });
    const query = `query($id:ID!){
  getRoleById(id: $id){
    data{
      id
      role
      description
    }
  }
}
              `;
    try {
      setPageState({ ...pageState, loading: true });
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // Extract Leavetype data from the response
      const departmentRowdata = response.data.data.getRoleById;

      setroleData({
        roleName: departmentRowdata.data[0].role,
        description: departmentRowdata.data[0].description,
      });

      setOriginalroleData({
        roleName: departmentRowdata.roleName,
        description: departmentRowdata.description,
      });
      setTogglePage({
        ...togglePage,
        view: true,
      });
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    } catch (error) {
      console.error("ResponseError:", error);

      setConfirmationDialog({
        open: true,
        title: "Error massage",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const handleroleDatachange = (event) => {
    let departmentState = { ...roleData };
    switch (event.target.name) {
      case "description": {
        const alphaNumberLengthRegex = new RegExp(
          "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~ ]{1,250}$"
        );
        if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
          departmentState[event.target.name + "Status"] = "success";
        } else {
          departmentState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "roleName": {
        const alphaNumberLengthRegex = new RegExp("^([a-zA-Z0-9 ]{1,35})$");
        if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
          departmentState[event.target.name + "Status"] = "success";
        } else {
          departmentState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      default:
        break;
    }
    departmentState[event.target.name] = event.target.value;
    setroleData(departmentState);
  };

  const onAddDepartment = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDepartmentSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const onDiscardDepartment = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setroleData({
      roleName: originalroleData.roleName,
      description: originalroleData.description,
    });
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      roleData.roleNameStatus === "success" &&
      roleData.descriptionStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      {pageState.state === "init" ? (
        <Card>
          <MaterialBox>
            <MaterialBox
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                height: "14vh",
                margin: "auto",
              }}
            >
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={2}
                padding={10}
              >
                <Grid size={{ xs: 6, sm: 6 }}>
                  <MaterialTypography variant="body2" mb={3}>
                    Please wait while we fetch the department details for you.
                    This may take a few seconds.
                  </MaterialTypography>
                  <MaterialBox
                    style={{
                      overflow: "hidden",
                      borderRadius: 5,
                      height: 24,
                    }}
                  >
                    <LinearProgress
                      size="lg"
                      color="dark"
                      thickness={16}
                      style={{
                        borderRadius: 5,
                        height: 16,
                        maxHeight: 16,
                      }}
                      sx={{
                        "& .MuiLinearProgress-bar": {
                          height: 16,
                        },
                      }}
                    />
                  </MaterialBox>
                </Grid>
              </Grid>
            </MaterialBox>
          </MaterialBox>
        </Card>
      ) : (
        <Card>
          <CardHeader
            title={
              <>
                {togglePage.view === true || togglePage.edit === true ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Role Details
                      </MaterialTypography>
                    </Stack>
                    {AccessData &&
                      Array.isArray(AccessData) &&
                      AccessData.some(
                        (item) =>
                          item.component === "EditRole" &&
                          item.can_access
                      ) &&
                      pageState.state !== "submitting" && (
                        <ButtonGroup
                          variant="outlined"
                          aria-label="Loading button group"
                        >
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={toggleEdit}
                            startIcon={<EditIcon />}
                          >
                            Edit
                          </MaterialButton>
                        </ButtonGroup>
                      )}
                  </Stack>
                ) : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Add Role Details
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                )}
              </>
            }
          />
          <CardContent
            sx={{
              minHeight: pageState.state === "submitting" ? "50vh" : "55vh",
            }}
          >
            {pageState.state === "error" && (
              <MaterialBox>
                <Grid container spacing={1} textAlign="center">
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <img
                      src={error}
                      alt="error"
                      style={{
                        width: "30%",
                      }}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography variant="h6" fontWeight="bold">
                        {pageState.message}
                      </MaterialTypography>
                    </MaterialBox>
                  </Grid>
                </Grid>
              </MaterialBox>
            )}

            {pageState.state === "default" && !pageState.loading && (
              <MaterialBox>
                <Grid container spacing={1}>
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Role <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="roleName"
                      value={roleData.roleName}
                      onChange={handleroleDatachange}
                      error={roleData.roleNameStatus === "error"}
                      success={roleData.roleNameStatus === "success"}
                      disabled={togglePage.view === true ? true : false}
                    />
                    {roleData.roleNameStatus === "error" && (
                      <FormControl error>
                        <FormHelperText>
                          Role should be a maximum of 25 characters long and can
                          contain alphabets & numbers.
                        </FormHelperText>
                      </FormControl>
                    )}
                  </Grid>
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Description <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      multiline
                      rows={5}
                      name="description"
                      // placeholder="eg. IT"
                      value={roleData.description}
                      onChange={handleroleDatachange}
                      error={roleData.descriptionStatus === "error"}
                      success={roleData.descriptionStatus === "success"}
                      disabled={togglePage.view === true ? true : false}
                    />
                    {roleData.descriptionStatus === "error" && (
                      <FormControl error>
                        <FormHelperText>
                          Description should be a maximum of 100 characters long
                          and can contain only alphabets.
                        </FormHelperText>
                      </FormControl>
                    )}
                  </Grid>
                </Grid>
              </MaterialBox>
            )}

            {pageState.state === "submitting" && !pageState.loading && (
              <MaterialBox>
                <MaterialBox
                  justifyContent="center"
                  alignItems="center"
                  display="flex"
                  flexDirection="column"
                  minHeight="50vh"
                >
                  <MaterialTypography
                    variant="h6"
                    fontWeight="bold"
                    textAlign="center"
                  >
                    Adding your deapartment data. This should not take much
                    time.
                  </MaterialTypography>
                  <MaterialBox mt={2}>
                    <img src={loading} alt="loading" width="200px" />
                  </MaterialBox>
                </MaterialBox>
              </MaterialBox>
            )}
          </CardContent>
          {pageState.state !== "submitting" && (
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              {togglePage.edit === true ? (
                <>
                  {/* <MaterialButton
                    variant="gradient"
                    color="dark"
                    disabled={pageState.state === "submitting"}
                    onClick={onDiscardDepartment}
                  >
                    Discard
                  </MaterialButton> */}

                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    onClick={onEditDepartmentSubmit}
                  >
                    Update
                  </MaterialButton>
                </>
              ) : togglePage.view === false && togglePage.edit === false ? (
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={
                    !checkAllFields() || pageState.state === "submitting"
                  }
                  onClick={onAddDepartment}
                >
                  Submit
                </MaterialButton>
              ) : null}
            </MaterialBox>
          )}
         
        </Card>
      )}
    </DashboardLayout>
  );
};

export default Rollcreation;
